module.exports = __webpack_public_path__ + "static/img/悬浮.c180f77.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/metallurgy/悬浮.png
// module id = sxFI
// module chunks = 1